(function(){
  const qs=(s,c=document)=>c.querySelector(s);
  const qsa=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const focusableSelector='a[href],button:not([disabled]),summary,textarea,input:not([type="hidden"]):not([disabled]),select,[tabindex]:not([tabindex="-1"])';
  const shopifyRoute=(path)=>((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path.replace(/^\//,'');
  let lastCartTrigger=null;
  let lastMenuTrigger=null;
  let lastLightboxTrigger=null;

  function shopifyRoot(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isMobileNavigation(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 980px)').matches);
  }

  function setMenu(open, trigger){
    const nav=qs('#PrimaryNavigation');
    const btn=trigger || qs('[data-mobile-menu]');
    if(!nav || !btn) return;
    if(!isMobileNavigation()){
      nav.classList.remove('is-open');
      document.documentElement.classList.remove('mobile-nav-open');
      setDrawerInert(nav,false);
      nav.setAttribute('aria-hidden','false');
      btn.setAttribute('aria-expanded','false');
      return;
    }
    nav.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('mobile-nav-open', open);
    setDrawerInert(nav,!open);
    nav.setAttribute('aria-hidden', String(!open));
    btn.setAttribute('aria-expanded', String(open));
    if(open){
      lastMenuTrigger=btn;
      const first=qs('a,button', nav);
      if(first) first.focus();
    }else if(lastMenuTrigger && typeof lastMenuTrigger.focus==='function'){
      lastMenuTrigger.focus();
    }
  }

  function setDrawerInert(drawer, inert){
    if(!drawer) return;
    if('inert' in drawer){ drawer.inert=!!inert; }
    if(inert) drawer.setAttribute('inert','');
    else drawer.removeAttribute('inert');
    qsa(focusableSelector, drawer).forEach(el=>{
      if(inert){
        if(!el.hasAttribute('data-prev-tabindex')) el.setAttribute('data-prev-tabindex', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex','-1');
      }else{
        const prev=el.getAttribute('data-prev-tabindex');
        if(prev!==null){
          if(prev==='') el.removeAttribute('tabindex');
          else el.setAttribute('tabindex',prev);
          el.removeAttribute('data-prev-tabindex');
        }
      }
    });
  }

  function openCart(trigger){
    const d=qs('#CartDrawer');
    if(!d) return;
    if(trigger) lastCartTrigger=trigger;
    setDrawerInert(d,false);
    d.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('cart-drawer-open');
    const close=qs('button[data-cart-close]',d);
    const panel=qs('.cart-drawer__panel',d);
    requestAnimationFrame(()=>{
      if(d.isConnected && d.getAttribute('aria-hidden')==='false') (close || panel || d).focus();
    });
  }

  function closeCart(){
    const d=qs('#CartDrawer');
    if(!d || d.getAttribute('aria-hidden')==='true') return;
    d.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('cart-drawer-open');
    setDrawerInert(d,true);
    if(lastCartTrigger && typeof lastCartTrigger.focus==='function') lastCartTrigger.focus();
  }

  function trapFocus(e, container){
    const focusables=qsa(focusableSelector, container).filter(el=>el.offsetParent!==null || el===document.activeElement);
    if(!focusables.length){ e.preventDefault(); return; }
    const first=focusables[0];
    const last=focusables[focusables.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }

  function showCartError(key){
    const drawer=qs('#CartDrawer');
    const target=qs('[data-cart-error]', drawer || document) || qs('[data-product-form-error]');
    const message=drawer && drawer.dataset[key];
    const linkLabel=drawer && drawer.dataset.viewCartLabel;
    if(!target || !message || !linkLabel){ window.location.assign(shopifyRoute('cart')); return; }
    const link=document.createElement('a');
    link.className='link-quiet';
    link.href=shopifyRoute('cart');
    link.textContent=linkLabel;
    target.replaceChildren(document.createTextNode(message+' '),link);
    target.hidden=false;
    if(drawer){
      drawer.dataset.cartStale='true';
      qsa('.cart-drawer__empty, .cart-drawer__form',drawer).forEach(el=>{ el.hidden=true; });
    }
  }

  function hideCartError(){
    qsa('[data-cart-error], [data-product-form-error]').forEach(el=>{
      if(el.closest('#CartDrawer')?.dataset.cartStale==='true') return;
      el.textContent=''; el.hidden=true;
    });
  }

  function syncCartCount(value){
    const count=Math.max(0,parseInt(value || '0',10) || 0);
    qsa('[data-cart-count]').forEach(el=>{ el.textContent=String(count); });
    qsa('[data-cart-open]').forEach(button=>{
      const label=button.dataset.cartLabel;
      if(label) button.setAttribute('aria-label',label+': '+count);
    });
  }

  function replaceCartDrawerFromHtml(html, open){
    const drawer=qs('#CartDrawer');
    if(!drawer) return false;
    const parsed=new DOMParser().parseFromString(html,'text/html');
    const fresh=parsed.querySelector('#CartDrawer');
    if(!fresh) return false;
    fresh.setAttribute('aria-hidden', open ? 'false' : 'true');
    drawer.replaceWith(fresh);
    setDrawerInert(fresh,!open);
    syncCartCount(fresh.dataset.cartItemCount);
    document.documentElement.classList.toggle('cart-drawer-open', open);
    return true;
  }

  async function refreshCartDrawer(options){
    const opts=Object.assign({ keepOpen:false }, options || {});
    const drawer=qs('#CartDrawer');
    if(!drawer || !window.fetch) return false;
    const shouldOpen=opts.keepOpen || drawer.getAttribute('aria-hidden')==='false';
    try{
      const root=shopifyRoot();
      const res=await fetch(root+'cart?section_id=cart-drawer',{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!res.ok) throw new Error('Cart drawer refresh failed');
      return replaceCartDrawerFromHtml(await res.text(), shouldOpen);
    }catch(err){ console.warn(err); return false; }
  }

  async function updateCartLine(lineKey, quantity){
    if(!lineKey || !window.fetch) return false;
    hideCartError();
    let outcome='unknown';
    try{
      const res=await fetch(shopifyRoute('cart/change.js'),{
        method:'POST',
        headers:{'Accept':'application/json','Content-Type':'application/json'},
        body:JSON.stringify({
          id:lineKey,
          quantity:Math.max(0, parseInt(quantity || '0', 10) || 0),
          sections:'cart-drawer',
          sections_url:window.location.pathname
        })
      });
      if(!res.ok){
        if(res.status===422 || res.status===429) outcome='failed';
        throw new Error('Cart update request failed');
      }
      const payload=await res.json();
      if(!payload || !Array.isArray(payload.items)) throw new Error('Cart update response could not be confirmed');
      outcome='updated';
      const sectionHtml=payload.sections && payload.sections['cart-drawer'];
      const replaced=(sectionHtml && replaceCartDrawerFromHtml(sectionHtml, true)) || await refreshCartDrawer({ keepOpen:true });
      if(!replaced) throw new Error('Cart drawer refresh failed after update');
      openCart();
      return true;
    }catch(err){
      console.warn(err);
      showCartError(outcome==='updated' ? 'updatedRefreshFailed' : outcome==='failed' ? 'updateFailed' : 'updateUncertain');
      return false;
    }
  }

  function ensureLightbox(){
    let lb=qs('#ThemeLightbox');
    if(lb) return lb;
    lb=document.createElement('div');
    lb.id='ThemeLightbox';
    lb.className='lightbox';
    lb.setAttribute('role','dialog');
    lb.setAttribute('aria-modal','true');
    lb.setAttribute('aria-labelledby','ThemeLightboxTitle');
    lb.setAttribute('aria-hidden','true');
    lb.setAttribute('tabindex','-1');
    const close=document.createElement('button');
    close.className='button lightbox__close';
    close.type='button';
    close.setAttribute('data-lightbox-close','');
    close.setAttribute('aria-label','Close image preview');
    close.textContent='Close';
    const title=document.createElement('h2');
    title.id='ThemeLightboxTitle';
    title.className='visually-hidden';
    title.textContent='Image preview';
    const img=document.createElement('img');
    img.alt='';
    lb.append(close,title,img);
    document.body.appendChild(lb);
    return lb;
  }

  function openLightbox(src,alt,trigger){
    const lb=ensureLightbox();
    lastLightboxTrigger=trigger || document.activeElement;
    qs('img',lb).src=src;
    qs('img',lb).alt=alt;
    lb.setAttribute('aria-hidden','false');
    lb.classList.add('is-open');
    document.documentElement.classList.add('lightbox-open');
    qs('button',lb).focus();
  }

  function closeLightbox(){
    const lb=qs('#ThemeLightbox');
    if(!lb || lb.getAttribute('aria-hidden')==='true') return;
    lb.setAttribute('aria-hidden','true');
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('lightbox-open');
    if(lastLightboxTrigger && typeof lastLightboxTrigger.focus==='function') lastLightboxTrigger.focus();
  }

  document.addEventListener('click', function(e){
    const menuBtn=e.target.closest('[data-mobile-menu]');
    if(menuBtn){
      const nav=qs('#PrimaryNavigation');
      setMenu(!(nav && nav.classList.contains('is-open')), menuBtn);
      return;
    }
    const nav=qs('#PrimaryNavigation');
    if(nav && nav.classList.contains('is-open') && !e.target.closest('#PrimaryNavigation') && !e.target.closest('[data-mobile-menu]')) setMenu(false);
    if(e.target.closest('#PrimaryNavigation a')) setMenu(false);

    const cartOpen=e.target.closest('[data-cart-open]');
    if(cartOpen){ openCart(cartOpen); }
    const cartClose=e.target.closest('[data-cart-close]');
    if(cartClose){ closeCart(); }

    const qty=e.target.closest('[data-qty]');
    if(qty){
      const input=qs('input[name="quantity"]', qty.closest('.quantity'));
      if(input){
        const delta=qty.dataset.qty==='plus'?1:-1;
        const current=parseInt(input.value||'1',10);
        input.value=String(Math.max(1,((Number.isFinite(current) ? current : 1)+delta)));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }

    const cartQty=e.target.closest('[data-cart-qty]');
    if(cartQty){
      const row=cartQty.closest('[data-cart-line-key]');
      const input=row ? qs('input[name="updates[]"]', row) : null;
      if(row && input){
        const delta=cartQty.dataset.cartQty==='plus'?1:-1;
        const current=parseInt(input.value||'0',10);
        const next=Math.max(0,((Number.isFinite(current) ? current : 0)+delta));
        input.value=String(next);
        updateCartLine(row.dataset.cartLineKey, next);
      }
    }

    const cartRemove=e.target.closest('[data-cart-remove]');
    if(cartRemove){
      updateCartLine(cartRemove.dataset.cartLineKey, 0);
    }

    const sticky=e.target.closest('[data-sticky-atc]');
    if(sticky){
      const form=qs('[data-product-form]');
      const submit=form && qs('button[type="submit"]',form);
      if(submit && !submit.disabled){
        if(submit.getBoundingClientRect().top >= window.innerHeight){
          form.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        }else submit.click();
      }
    }

    const thumbnail=e.target.closest('[data-product-thumbnail]');
    if(thumbnail){
      e.preventDefault();
      selectProductThumbnail(thumbnail);
      return;
    }

    const media=e.target.closest('[data-lightbox-src]');
    if(media){
      const src=media.dataset.lightboxSrc || media.getAttribute('src');
      if(src) openLightbox(src, media.getAttribute('alt')||media.getAttribute('aria-label')||'Product image', media);
    }
    if(e.target.matches('[data-lightbox-close]') || e.target.id==='ThemeLightbox') closeLightbox();
  });

  document.addEventListener('change', function(e){
    const cartInput=e.target.closest('[data-cart-line-key] input[name="updates[]"]');
    if(cartInput){
      const row=cartInput.closest('[data-cart-line-key]');
      if(row) updateCartLine(row.dataset.cartLineKey, cartInput.value);
    }
  });

  document.addEventListener('keydown', function(e){
    const drawer=qs('#CartDrawer');
    const lightbox=qs('#ThemeLightbox');
    const catalogFilter=isMobileNavigation() ? qs('.catalog-filter-panel[open]') : null;
    if(e.key==='Escape'){
      setMenu(false);
      closeCart();
      closeLightbox();
      if(catalogFilter){
        const trigger=qs('.catalog-filter-toggle',catalogFilter);
        catalogFilter.open=false;
        if(trigger) requestAnimationFrame(()=>trigger.focus());
      }
      return;
    }
    if(e.key==='Tab' && lightbox && lightbox.getAttribute('aria-hidden')==='false') trapFocus(e, lightbox);
    else if(e.key==='Tab' && drawer && drawer.getAttribute('aria-hidden')==='false') trapFocus(e, drawer);
    else if(e.key==='Tab' && catalogFilter) trapFocus(e, catalogFilter);
    else if(e.key==='Tab' && isMobileNavigation() && qs('#PrimaryNavigation.is-open')) trapFocus(e, qs('#PrimaryNavigation'));
  });

  document.addEventListener('cart:refresh', async function(){ await refreshCartDrawer({ keepOpen: true }); });

  function syncStickyAtc(available, text){
    qsa('[data-sticky-atc]').forEach(btn=>{
      btn.disabled=!available;
      btn.setAttribute('aria-disabled', String(!available));
      const label=qs('[data-sticky-atc-text]', btn) || btn;
      label.textContent=text || (available ? 'Add' : 'Sold out');
    });
  }

  function initStickyAtcVisibility(){
    const bar=qs('.sticky-atc');
    const primarySubmit=qs('[data-product-form] button[type="submit"]');
    if(!bar || !primarySubmit) return;
    const button=qs('[data-sticky-atc]',bar);
    const label=qs('[data-sticky-atc-text]',bar);
    const update=()=>{
      const rect=primarySubmit.getBoundingClientRect();
      const outside=rect.bottom<=0 || rect.top>=window.innerHeight;
      const blocked=document.documentElement.matches('.cart-drawer-open,.catalog-filter-open,.lightbox-open') || !!qs('dialog[open],.lightbox.is-open');
      const show=outside && isMobileNavigation() && !blocked;
      bar.classList.toggle('is-visible',show);
      bar.setAttribute('aria-hidden',String(!show));
      bar.inert=!show;
      if(document.documentElement.classList.contains('sticky-atc-open')!==show)document.documentElement.classList.toggle('sticky-atc-open',show);
      if(label && button && !primarySubmit.disabled){
        label.textContent=rect.top>=window.innerHeight ? button.dataset.optionsLabel : (qs('[data-atc-text]',primarySubmit)?.textContent || primarySubmit.textContent).trim();
      }
    };
    if('IntersectionObserver' in window)new IntersectionObserver(update,{threshold:[0,1]}).observe(primarySubmit);
    new MutationObserver(update).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    document.addEventListener('change',update);
    update();
  }

  initStickyAtcVisibility();

  function formatMoney(cents){
    const value=Number(cents || 0);
    if(window.Shopify && typeof window.Shopify.formatMoney==='function'){
      return window.Shopify.formatMoney(value, window.themeMoneyFormat || '${{amount}}');
    }
    const currency=(window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.themeCurrency || 'USD';
    try{
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(value/100);
    }catch(err){
      return (value/100).toFixed(2)+' '+currency;
    }
  }

  function selectProductThumbnail(thumbnail){
    if(!thumbnail) return;
    const section=thumbnail.closest('[data-product-id]') || document;
    const stage=qs('[data-product-media-stage]',section);
    const image=stage ? qs('img',stage) : null;
    const src=thumbnail.dataset.productMediaSrc;
    if(!image || !src) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src=src;
    image.alt=thumbnail.dataset.productMediaAlt || image.alt || '';
    const zoom=qs('[data-lightbox-src]',stage);
    if(zoom){
      zoom.dataset.lightboxSrc=thumbnail.dataset.productMediaZoom || src;
      zoom.setAttribute('aria-label','View a larger image of '+(image.alt || 'this product'));
    }
    qsa('[data-product-thumbnail]',section).forEach(button=>{
      const active=button===thumbnail;
      button.classList.toggle('is-active',active);
      if(active) button.setAttribute('aria-current','true');
      else button.removeAttribute('aria-current');
    });
  }

  function syncVariantPrice(match,scope){
    const price=qs('[data-product-price]',scope);
    if(!price) return;
    const current=Number(match.price || 0);
    const compare=Number(match.compare_at_price || 0);
    const currentElement=document.createElement('span');
    currentElement.className='price';
    currentElement.textContent=current>0 ? formatMoney(current) : 'Request quote';
    const nodes=[currentElement];
    if(compare>current){
      const compareElement=document.createElement('s');
      compareElement.className='product-price__compare';
      compareElement.textContent=formatMoney(compare);
      const saving=document.createElement('span');
      saving.className='badge product-price__saving';
      saving.textContent='Save '+Math.round(((compare-current)/compare)*100)+'%';
      nodes.push(compareElement,saving);
    }
    price.replaceChildren(...nodes);
    qsa('[data-sticky-price]').forEach(el=>{ el.textContent=current>0 ? formatMoney(current) : ''; });
  }

  function syncVariantAvailability(match,scope){
    const available=!!match.available;
    const availability=qs('[data-product-availability]',scope);
    if(availability){
      availability.classList.toggle('is-unavailable',!available);
      const label=qs('[data-product-availability-text]',availability);
      if(label) label.textContent=available ? availability.dataset.availableText : availability.dataset.unavailableText;
    }
    const dynamic=qs('[data-dynamic-checkout]',scope);
    if(dynamic) dynamic.hidden=!available;
    const skuWrap=qs('[data-product-sku-wrap]',scope);
    const sku=qs('[data-product-sku]',scope);
    if(skuWrap && sku){
      sku.textContent=match.sku || '';
      skuWrap.hidden=!match.sku;
    }
  }

  function syncVariantMedia(match,scope){
    const featured=match.featured_media || match.featured_image;
    const mediaId=featured && featured.id;
    if(!mediaId) return;
    const thumbnail=qsa('[data-product-thumbnail]',scope).find(button=>button.dataset.productMediaId===String(mediaId));
    if(thumbnail){
      selectProductThumbnail(thumbnail);
      return;
    }

    const preview=featured.preview_image || match.featured_image;
    const src=preview && preview.src;
    const stage=qs('[data-product-media-stage]',scope);
    const image=stage ? qs('img',stage) : null;
    if(!image || !src) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src=src;
    image.alt=featured.alt || preview.alt || image.alt || '';
    const zoom=qs('[data-lightbox-src]',stage);
    if(zoom){
      zoom.dataset.lightboxSrc=src;
      zoom.setAttribute('aria-label','View a larger image of '+(image.alt || 'this product'));
    }
    qsa('[data-product-thumbnail]',scope).forEach(button=>{
      button.classList.remove('is-active');
      button.removeAttribute('aria-current');
    });
  }

  qsa('[data-product-form]').forEach(form=>{
    const idInput=qs('input[name="id"]',form);
    const json=qs('[data-variants-json]',form);
    const initialSubmit=qs('button[type="submit"]',form);
    const scope=form.closest('[data-product-id]') || document;
    const initialAtcText=initialSubmit && qs('[data-atc-text]',initialSubmit) ? qs('[data-atc-text]',initialSubmit).textContent : 'Add';
    const availabilityNode=qs('[data-product-availability]',scope);
    const unavailableAtcText=availabilityNode && availabilityNode.dataset.unavailableText ? availabilityNode.dataset.unavailableText : initialAtcText;
    syncStickyAtc(!!(initialSubmit && !initialSubmit.disabled), initialAtcText);
    if(!idInput||!json) return;
    let variants=[];
    try{variants=JSON.parse(json.textContent)}catch(e){}

    qsa('input[type="radio"]',form).forEach(r=>r.addEventListener('change',()=>{
      const selected=qsa('fieldset[data-option-index]',form).map(fs=>qs('input:checked',fs)?.value).filter(Boolean);
      const match=variants.find(v=>selected.every((val,i)=>v.options[i]===val));
      if(match){
        idInput.value=match.id;
        form.dataset.currentVariantAvailable=String(!!match.available);
        syncVariantPrice(match,scope);
        syncVariantAvailability(match,scope);
        syncVariantMedia(match,scope);
        qsa('[data-custom-inquiry]',scope).forEach(link=>{
          const inquiryUrl=new URL(link.href,window.location.origin);
          inquiryUrl.searchParams.set('variant',match.id);
          inquiryUrl.searchParams.set('options',match.options.join(' / '));
          link.href=inquiryUrl.toString();
        });
        qsa('[data-atc-text]',form).forEach(el=>el.textContent=match.available?initialAtcText:unavailableAtcText);
        qsa('button[type="submit"]',form).forEach(btn=>btn.disabled=!match.available);
        syncStickyAtc(match.available, match.available ? initialAtcText : unavailableAtcText);
        hideCartError();
        if(window.history && window.history.replaceState){
          const url=new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }else{
        form.dataset.currentVariantAvailable='false';
        qsa('[data-atc-text]',form).forEach(el=>el.textContent=unavailableAtcText);
        qsa('button[type="submit"]',form).forEach(btn=>btn.disabled=true);
        syncStickyAtc(false, unavailableAtcText);
      }
    }));

    form.addEventListener('submit', async function(e){
      if(!window.fetch || !form.dataset.ajaxCart) return;
      e.preventDefault();
      if(form.dataset.cartSubmitting==='true') return;
      form.dataset.cartSubmitting='true';
      hideCartError();
      const btn=qs('button[type="submit"]',form);
      const label=btn ? qs('[data-atc-text]', btn) : null;
      const originalText=label ? label.textContent : '';
      if(btn){ btn.disabled=true; btn.setAttribute('aria-busy','true'); }
      if(label) label.textContent=initialAtcText;
      let outcome='unknown';
      try{
        const body=new FormData(form);
        body.append('sections','cart-drawer');
        body.append('sections_url', window.location.pathname);
        const root=shopifyRoot();
        const res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body});
        if(!res.ok){
          if(res.status===422 || res.status===429) outcome='failed';
          throw new Error('Cart add request failed');
        }
        const payload=await res.json();
        if(!payload || !(payload.id || payload.key || payload.items?.some(item=>item.id))) throw new Error('Cart add response could not be confirmed');
        outcome='added';
        const sectionHtml=payload.sections && payload.sections['cart-drawer'];
        const replaced=(sectionHtml && replaceCartDrawerFromHtml(sectionHtml, true)) || await refreshCartDrawer({ keepOpen:true });
        if(!replaced) throw new Error('Cart drawer refresh failed after add');
        openCart(btn);
      }catch(err){
        console.warn(err);
        showCartError(outcome==='added' ? 'addedRefreshFailed' : outcome==='failed' ? 'addFailed' : 'addUncertain');
        openCart(btn);
      }finally{
        delete form.dataset.cartSubmitting;
        if(label) label.textContent=originalText || initialAtcText;
        if(btn){
          btn.disabled=form.dataset.currentVariantAvailable==='false';
          btn.removeAttribute('aria-busy');
        }
      }
    });
  });

  function syncCatalogFilterState(event){
    const activePanel=isMobileNavigation() ? qs('.catalog-filter-panel[open]') : null;
    const hasOpenMobileFilter=!!activePanel;
    document.documentElement.classList.toggle('catalog-filter-open',hasOpenMobileFilter);
    qsa('.catalog-filter-panel').forEach(panel=>{
      if(panel===activePanel){
        panel.setAttribute('role','dialog');
        panel.setAttribute('aria-modal','true');
      }else{
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    });
    if(hasOpenMobileFilter && event && event.currentTarget===activePanel){
      const trigger=qs('.catalog-filter-toggle',activePanel);
      if(trigger) requestAnimationFrame(()=>trigger.focus());
    }
  }

  qsa('.catalog-filter-panel').forEach(panel=>{
    panel.addEventListener('toggle',syncCatalogFilterState);
  });

  function syncCatalogFilterViewport(){
    const mobile=isMobileNavigation();
    qsa('.catalog-filter-panel').forEach(panel=>{
      if(!mobile){
        panel.dataset.desktopExpanded='true';
        panel.open=true;
      }else if(panel.dataset.desktopExpanded==='true'){
        panel.open=false;
        delete panel.dataset.desktopExpanded;
      }
    });
    syncCatalogFilterState();
  }

  window.addEventListener('resize',syncCatalogFilterViewport);
  syncCatalogFilterViewport();

  qsa('[data-filter-search]').forEach(input=>{
    input.addEventListener('input',()=>{
      const list=input.closest('.catalog-filter__body')?.querySelector('[data-filter-values]');
      if(!list) return;
      const query=input.value.trim().toLocaleLowerCase(document.documentElement.lang || undefined);
      qsa('li',list).forEach(item=>{
        item.hidden=query!=='' && !item.textContent.toLocaleLowerCase(document.documentElement.lang || undefined).includes(query);
      });
    });
  });

  const productQueryField=qs('[data-product-query-field]');
  if(productQueryField && !productQueryField.value){
    const productHandle=new URLSearchParams(window.location.search).get('product');
    const inquiryParams=new URLSearchParams(window.location.search);
    if(productHandle) productQueryField.value=inquiryParams.get('model') || productHandle.replace(/-/g,' ');
    const requestedVariant=qs('[data-requested-variant]');
    if(requestedVariant) requestedVariant.value=inquiryParams.get('variant') || '';
    const requestedOptions=qs('[data-requested-options]');
    if(requestedOptions) requestedOptions.value=inquiryParams.get('options') || '';
  }

  class ProductRecommendations extends HTMLElement{
    connectedCallback(){
      const url=this.dataset.url;
      if(!url || this.dataset.loaded==='true' || !window.fetch) return;
      this.dataset.loaded='true';
      fetch(url)
        .then(res=>res.ok?res.text():Promise.reject(new Error('Recommendations failed')))
        .then(html=>{
          const parsed=new DOMParser().parseFromString(html,'text/html');
          const fresh=parsed.querySelector('product-recommendations');
          if(fresh && fresh.innerHTML.trim()){
            this.replaceChildren(...Array.from(fresh.childNodes).map(node=>document.importNode(node,true)));
            this.closest('[data-recommendations-section]')?.removeAttribute('hidden');
          }
        })
        .catch(err=>console.warn(err));
    }
  }
  if(!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  function syncNavigationMode(){
    const nav=qs('#PrimaryNavigation');
    const btn=qs('[data-mobile-menu]');
    if(!nav || !btn) return;
    if(isMobileNavigation()){
      const open=nav.classList.contains('is-open');
      setDrawerInert(nav,!open);
      document.documentElement.classList.toggle('mobile-nav-open',open);
      nav.setAttribute('aria-hidden',String(!open));
      btn.setAttribute('aria-expanded',String(open));
    }else{
      nav.classList.remove('is-open');
      document.documentElement.classList.remove('mobile-nav-open');
      setDrawerInert(nav,false);
      nav.setAttribute('aria-hidden','false');
      btn.setAttribute('aria-expanded','false');
    }
    syncCatalogFilterState();
  }

  syncNavigationMode();
  if(window.matchMedia){
    const navigationMedia=window.matchMedia('(max-width: 980px)');
    if(typeof navigationMedia.addEventListener==='function') navigationMedia.addEventListener('change',syncNavigationMode);
    else if(typeof navigationMedia.addListener==='function') navigationMedia.addListener(syncNavigationMode);
  }
  qsa('#CartDrawer[aria-hidden="true"]').forEach(drawer=>setDrawerInert(drawer,true));
})();
